import React from "react";
import MagnifyingGlassImage from "../../assets/header/MagnifyingGlass.svg";
import { Link } from "react-router-dom";

const SearchButton = ({toggleSearch}) => {
  return (
    <button
      // to="/articles#articles_archieve_section"
      onClick={toggleSearch}
      className="w-0 aspect-square rounded-full ml-auto hover:bg-white hover:p-0.5 duration-150 lg:w-10"
    >
      <img src={MagnifyingGlassImage} className="max-h-10" />
    </button>
  );
};

export default SearchButton;
